<app-background-card
  title="{{ 'common.selecthor.admin.provider.list.title' | transloco }}"
  titleTestId="provider-list-header"
  testId="provider-list-card"
>
  @if (loading()) {
    <app-loading data-testid="provider-list-loading" />
  } @else {
    @if (hasProviders()) {
      <p-table
        #dt
        data-testid="provider-list-table"
        [value]="providers()"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'common.table.currentPageReportTemplate' | transloco }}"
        [responsiveLayout]="'scroll'"
        [globalFilterFields]="globalFilterFields"
        [loading]="loading()"
        [sortField]="sortField()"
        [sortOrder]="sortOrder()"
        (onSort)="onSort($event)"
        class="p-datatable-striped"
        dataKey="tenantId"
        [expandedRowKeys]="expandedRows()"
      >
        <ng-template #caption>
          <div class="flex justify-between items-center">
            <app-table-expand-controls (expandAll)="expandAll()" (collapseAll)="collapseAll()" />
            <app-global-search
              testId="provider-list-search"
              (searchValue)="dt.filterGlobal($event, 'contains')"
            />
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <th class="w-20"></th>
            <th
              pSortableColumn="companyName"
              data-testid="provider-name-header"
              class="w-[20%]"
              scope="col"
            >
              {{ 'selecthorAdmin.providerList.providerCompanyName' | transloco }}
              <p-sortIcon field="companyName" />
            </th>
            <th
              pSortableColumn="adminLastName"
              data-testid="admin-name-header"
              class="w-[12%]"
              scope="col"
            >
              {{ 'selecthorAdmin.providerList.adminName' | transloco }}
              <p-sortIcon field="adminLastName" />
            </th>
            <th
              pSortableColumn="adminEmail"
              data-testid="admin-email-header"
              class="w-[15%]"
              scope="col"
            >
              {{ 'selecthorAdmin.providerList.adminEmail' | transloco }}
              <p-sortIcon field="adminEmail" />
            </th>
            <th class="w-[10%]" scope="col">
              {{ 'selecthorAdmin.providerList.contractStatus' | transloco }}
            </th>
            <th class="w-[11%]" scope="col">
              {{ 'selecthorAdmin.providerList.contractStart' | transloco }}
            </th>
            <th class="w-[11%]" scope="col">
              {{ 'selecthorAdmin.providerList.contractEnd' | transloco }}
            </th>
            <th data-testid="plan-header" class="w-[11%]" scope="col">
              {{ 'selecthorAdmin.providerList.plan' | transloco }}
            </th>
            <th class="w-20"></th>
          </tr>
        </ng-template>

        <ng-template #body let-provider let-expanded="expanded">
          <tr data-testid="provider-list-row">
            <td>
              <p-button
                type="button"
                pRipple
                [pRowToggler]="provider"
                [text]="true"
                [rounded]="true"
                [plain]="true"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              />
            </td>
            <td>
              <span class="font-medium">{{ provider.companyName }}</span>
            </td>
            <td>{{ provider.adminFirstName }} {{ provider.adminLastName }}</td>
            <td>
              <a
                [href]="'mailto:' + provider.adminEmail"
                class="text-secondary hover:text-secondary/80"
              >
                {{ provider.adminEmail }}
              </a>
            </td>
            <td>
              <app-options-select
                [options]="providerContractStatusOptions"
                [value]="provider.status"
                (valueChange)="onStatusChange(provider, $event)"
                placeholder="selecthorAdmin.providerList.selectStatus"
                [disabled]="saving()"
              />
            </td>
            <td>
              <p-datePicker
                [id]="provider.tenantId + 'contractStart-datepicker'"
                [ngModel]="provider.contractStart"
                (ngModelChange)="onDateChange(provider, 'contractStart', $event)"
                [showButtonBar]="true"
                [showIcon]="true"
                [disabled]="saving()"
                dateFormat="dd/mm/yy"
                class="w-full"
                iconDisplay="input"
                appendTo="body"
              ></p-datePicker>
            </td>
            <td>
              <p-datePicker
                [id]="provider.tenantId + 'contractEnd-datepicker'"
                [ngModel]="provider.contractEnd"
                (ngModelChange)="onDateChange(provider, 'contractEnd', $event)"
                [showButtonBar]="true"
                [showIcon]="true"
                [disabled]="saving()"
                dateFormat="dd/mm/yy"
                class="w-full"
                iconDisplay="input"
                appendTo="body"
              ></p-datePicker>
            </td>
            <td>
              <app-select
                data-testid="plan-select"
                [options]="providerPaymentPlans()"
                [placeholder]="'selecthorAdmin.providerList.selectPlan'"
                [relationshipId]="provider.selectedPlan"
                (relationshipIdChange)="onPlanChange(provider, $event)"
                [disabled]="saving()"
              ></app-select>
            </td>
            <td>
              <p-button
                data-testid="contract-details-button"
                icon="pi pi-pencil"
                [text]="true"
                [rounded]="true"
                (onClick)="openContractDetails(provider)"
                [disabled]="saving()"
              />
            </td>
          </tr>
        </ng-template>

        <ng-template #expandedrow let-provider>
          <tr>
            <td colspan="9" class="p-0!">
              <p-table
                [value]="provider.tools"
                [rows]="10"
                [paginator]="true"
                [responsiveLayout]="'scroll'"
                [loading]="loading()"
                dataKey="id"
              >
                <ng-template #caption>
                  <div class="flex justify-start">Produkte</div>
                </ng-template>

                <ng-template #header>
                  <tr>
                    <th scope="col">
                      {{ 'selecthorAdmin.providerList.tool.name' | transloco }}
                    </th>
                    <th scope="col">
                      {{ 'selecthorAdmin.providerList.tool.minEmployeeCount' | transloco }}
                    </th>
                    <th scope="col">
                      {{ 'selecthorAdmin.providerList.tool.maxEmployeeCount' | transloco }}
                    </th>
                    <th scope="col">
                      {{ 'selecthorAdmin.providerList.tool.moduleFunctions' | transloco }}
                    </th>
                  </tr>
                </ng-template>

                <ng-template #body let-tool let-rowIndex="rowIndex">
                  <tr>
                    <td>
                      <span class="font-medium">{{ tool.name }}</span>
                    </td>
                    <td>
                      <p-inputNumber
                        [name]="'minCount-' + tool.id + '-' + rowIndex"
                        inputId="minEmployeeCount"
                        mode="decimal"
                        [(ngModel)]="tool.minEmployeeCount"
                        [min]="0"
                        [showButtons]="true"
                        class="w-full"
                        [disabled]="true"
                      ></p-inputNumber>
                    </td>
                    <td>
                      <p-inputNumber
                        [name]="'maxCount-' + tool.id + '-' + rowIndex"
                        inputId="maxEmployeeCount"
                        mode="decimal"
                        [(ngModel)]="tool.maxEmployeeCount"
                        [min]="0"
                        [showButtons]="true"
                        class="w-full"
                        [disabled]="true"
                      ></p-inputNumber>
                    </td>
                    <td>
                      @for (moduleFunction of tool.moduleFunctions; track moduleFunction.id) {
                        <p-chip [label]="moduleFunction.name" />
                      }
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="9" class="text-center py-4">
              {{ 'common.noDataAvailable' | transloco }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      @if (shouldShowSaveButton()) {
        <div class="flex justify-end gap-2 mt-6">
          <p-button
            appConfirmStepLeaveDirective
            data-testid="save-changes-button"
            [label]="'common.save' | transloco"
            (onClick)="saveAllChanges()"
            [loading]="saving()"
            [disabled]="saving()"
            styleClass="px-8! text-sm! uppercase"
          ></p-button>
        </div>
      }

      <app-contract-details-dialog
        [visible]="contractDetailsVisible()"
        [provider]="selectedProvider()"
        (visibleChange)="closeContractDetails()"
        (applied)="onContractDetailsApplied($event)"
      />
    } @else {
      <app-no-data
        icon="pi pi-briefcase"
        label="selecthorAdmin.providerList.emptyListText"
        testId="empty-provider-list"
        textTestId="empty-provider-list-text"
      />
    }
  }
</app-background-card>
